import { render, staticRenderFns } from "./image-ad-element.vue?vue&type=template&id=1af23e42&scoped=true&"
import script from "./image-ad-element.vue?vue&type=script&lang=js&"
export * from "./image-ad-element.vue?vue&type=script&lang=js&"
import style0 from "./image-ad-element.vue?vue&type=style&index=0&id=1af23e42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af23e42",
  null
  
)

export default component.exports